export const Colors={
    primary:'#061539',
    seconday:'#E83D3D',
    yellowLight:'#FFB769'
}